import script from "./LayoutNext.vue?vue&type=script&setup=true&lang=js"
export * from "./LayoutNext.vue?vue&type=script&setup=true&lang=js"

import "./LayoutNext.vue?vue&type=style&index=0&id=67d4b07b&lang=css"
import "./LayoutNext.vue?vue&type=style&index=1&id=67d4b07b&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\CSD.SPA\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67d4b07b"]])

export default __exports__